module.exports = __webpack_public_path__ + "img/xitongyunwei.f501c81b.png";